import { render, staticRenderFns } from "./CreateSpokespersonModal.vue?vue&type=template&id=531cf498&"
import script from "./CreateSpokespersonModal.vue?vue&type=script&lang=js&"
export * from "./CreateSpokespersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531cf498')) {
      api.createRecord('531cf498', component.options)
    } else {
      api.reload('531cf498', component.options)
    }
    module.hot.accept("./CreateSpokespersonModal.vue?vue&type=template&id=531cf498&", function () {
      api.rerender('531cf498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/CreateSpokespersonModal.vue"
export default component.exports